import React, { useEffect, useRef, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { BsEyeFill } from "react-icons/bs";
import { RiArrowDropDownLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import ReviewInformation from "../../../../components/customer/policy application/ReviewInformation";
import RiskInformation from "../../../../components/customer/policy application/RiskInformation";
import Transactions from "../../../../components/customer/policy application/Transactions";
import ModalContainer from "../../../../components/modals/ModalContainer";
import ConfirmUnderwrite from "../../../../components/modals/policy/ConfirmUnderwrite";
import PayPremium from "../../../../components/modals/policy/PayPremium";
import PreviewPolicyAppSchedule from "../../../../components/modals/preview/PreviewPolicyAppSchedule";
import PageTitle from "../../../../components/partials/PageTitle";
import PaymentSchedule from "../../../../components/policy/PaymentSchedule";
import { getAllCovers } from "../../../../redux/slice/cover/coverSlice";
import {
  getSinglePolicyCover,
  getSinglePolicyHistory,
  resetPolicyStatus,
  resetRiskCover,
} from "../../../../redux/slice/policy/policySlice";
import {
  getPolicyDocument,
  resetUnderwriting,
  resetUnderwritingStatus,
} from "../../../../redux/slice/underwriting/underwritingSlice";
import PolicyClaimHistory from "./PolicyClaimHistory";

const PolicyCycleView = () => {
  const {
    customer_policy_details,
    policy_history_details,
    isLoading,
    isPolicyEdited,
    isSuccess,
  } = useSelector((state) => state.policy);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const [underwrite, setUnderwrite] = useState();
  const [premiumPayment, setPremiumPayment] = useState();
  const [dropdownShow, setDropdownShow] = useState(false);

  const { state } = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const breadcrumb = {
    from: {
      title: "customer policy view",
      link: "/admin/customer-policy-view",
    },
    current: {
      title: "Policy history",
      link: null,
    },
  };

  //   local state declarations
  const [tab, setTab] = useState("details");

  const dispatch = useDispatch();

  const temp_policy_attach_data = {
    effective_date: policy_history_details?.policy_app_details?.effectiveDate,
    end_date: policy_history_details?.policy_app_details?.endDate,
    repayment_frequency:
      policy_history_details?.policy_app_details?.repayment_frequency,
    but_charge: policy_history_details?.policy_app_details?.butCharge,
    total_annual_premium: parseInt(
      policy_history_details?.policy_app_details?.totalPremium
    ),
    policy_id: state?.policy_id,
    customer_id: policy_history_details?.policy_app_details?.customerId,
  };

  useEffect(() => {
    if (state?.customerId) {
      dispatch(
        getSinglePolicyHistory({
          customer_id: state?.customerId,
          policy_number: state?.policyAppNumber,
          policy_cycle: state?.policy_cycle,
        })
      );
      dispatch(
        getPolicyDocument({
          customer_id: state?.customerId,
          policy_application_number: state?.policyAppNumber,
        })
      );
      dispatch(getAllCovers(1));
    }

    if (state?.policy_id) {
      dispatch(getAllCovers(1));
      dispatch(getSinglePolicyCover(state?.policy_id));
    }

    dispatch(resetUnderwritingStatus());
    dispatch(resetUnderwriting());
    dispatch(resetRiskCover());
  }, []);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetPolicyStatus());
    }
  }, [isSuccess]);

  useEffect(() => {
    setUnderwrite(
      user_permissions?.some((permission) => permission.name === "underwrite")
    );
    setPremiumPayment(
      user_permissions?.some(
        (permission) => permission.name === "premium payment"
      )
    );
  }, [user_permissions]);

  // control of dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector(".more_actions_drowdown");
      if (
        dropdown &&
        !dropdown.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      )
        setDropdownShow(false);
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  if (!policy_history_details) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy History' breadcrumb={breadcrumb} />
      {/* end page title */}

      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <div className='card-body'>
              <div className='d-flex justify-content-between mb-2'>
                <h4 className='text-primary'>
                  Policy Cycle {state?.policy_cycle}
                </h4>
                <button
                  className='btn btn-sm btn-primary d-flex align-items-center'
                  onClick={() => navigate(-1)}
                >
                  <BiArrowBack />
                  <span>Back</span>
                </button>
              </div>
              <div className='border border-1 rounded-1 p-2'>
                <div className='row'>
                  <div className='col-md-10'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='d-flex align-items-center gap-2'>
                          <h5>Customer Name: </h5>
                          <Link
                            to={`/admin/customer-profile/${policy_history_details?.policy_app_details?.customer_uuid}`}
                          >
                            {policy_history_details?.policy_app_details
                              ?.customerFirstName +
                              " " +
                              policy_history_details?.policy_app_details
                                ?.customerLastName}
                          </Link>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='d-flex align-items-center gap-2'>
                          <h5>Marketer/Agent:</h5>
                          <span>
                            {policy_history_details?.policy_app_details
                              ?.agentFirstName +
                              " " +
                              policy_history_details?.policy_app_details
                                ?.agentLastName}
                          </span>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='d-flex align-items-center gap-2'>
                          <h5>Customer ID:</h5>
                          <span>
                            {
                              policy_history_details?.policy_app_details
                                ?.customerId
                            }
                          </span>
                        </div>
                      </div>
                      {/* <div className='col-md-6'>
                            <div className='d-flex align-items-center gap-2'>
                            <h5>Marketer/Agent:</h5>
                            <span>Friday Francis</span>
                            </div>
                        </div> */}
                    </div>
                  </div>
                </div>
                <div className='d-flex my-1'>
                  {policy_history_details?.policy_app_details?.status ===
                  "1" ? (
                    <div>
                      {underwrite && (
                        <Link
                          to={"/admin/customer-policy-view/underwrite"}
                          // className='btn btn-sm btn-primary me-2 mt-1 text-white col-md-2 col-sm-3'
                        >
                          <span className='btn btn-sm btn-primary me-2 mt-1 text-white col-md- col-sm-'>
                            Under-write
                          </span>
                        </Link>
                      )}
                    </div>
                  ) : (
                    <div className='d-flex me-2'>
                      {premiumPayment && (
                        <div
                          className='btn btn-sm btn-primary me-2 mt-1 '
                          // data-bs-toggle='modal'
                          // data-bs-target='#pay_premium'
                          onClick={() =>
                            navigate(
                              "/admin/customer-policy-view/policy-schedule",
                              { state: "policy-history" }
                            )
                          }
                        >
                          Policy Document <BsEyeFill className='ms-1' />
                        </div>
                      )}
                      <div className='position-relative'>
                        <div
                          className='btn btn-sm btn-primary me- mt-1'
                          onClick={() => setDropdownShow(!dropdownShow)}
                          ref={dropdownRef}
                        >
                          <span>More Actions</span>
                          <span>
                            <RiArrowDropDownLine size={20} />
                          </span>
                        </div>
                        <div
                          className={`position-absolute shadow-lg rounded-2 p- more_actions_drowdown ${
                            dropdownShow ? "show" : ""
                          }`}
                        >
                          <ul className='w-100'>
                            <li
                              onClick={() => {
                                setDropdownShow(!dropdownShow);
                              }}
                              data-bs-toggle='modal'
                              data-bs-target='#policy_schedule'
                            >
                              View Payment Schedule
                            </li>
                            {/* <li onClick={() => setDropdownShow(!dropdownShow)}>
                              Debit Note
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {policy_history_details ? (
                  <div className='row my-3'>
                    <div>
                      <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                        <li className='nav-item cursor-p'>
                          <span
                            onClick={() => setTab("details")}
                            aria-expanded='false'
                            className={`nav-link rounded-0 p-tab-y-1 ${
                              tab === "details" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-home-variant d-md-none d-block'></i>
                            <span className='d-none d-md-block'>Details</span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("risk_covered")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "risk_covered" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Risk Covered
                            </span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("schedule")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "schedule" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Payment Schedule
                            </span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("transaction")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "transaction" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Transactions
                            </span>
                          </span>
                        </li>
                        <li className='nav-item cursor-p'>
                          <span
                            // data-bs-toggle='tab'
                            onClick={() => setTab("claim_hisot")}
                            aria-expanded='true'
                            className={`nav-link rounded-0 ${
                              tab === "claim_hisot" && "active"
                            } border`}
                          >
                            <i className='mdi mdi-account-circle d-md-none d-block'></i>
                            <span className='d-none d-md-block'>
                              Claim History
                            </span>
                          </span>
                        </li>
                      </ul>

                      {tab === "details" && (
                        <div className='details active' id='details'>
                          <ReviewInformation
                            details={policy_history_details?.policy_app_details}
                          />
                        </div>
                      )}
                      {tab === "risk_covered" && (
                        <div className='active' id='risk_covered'>
                          <RiskInformation
                            details={policy_history_details?.policy_app_rsk}
                          />
                        </div>
                      )}
                      {tab === "schedule" && (
                        <div className='active' id='schedule'>
                          <PaymentSchedule history />
                        </div>
                      )}
                      {tab === "transaction" && (
                        <div className='active' id='transaction'>
                          <Transactions
                            customerTransactions={
                              policy_history_details?.customer_transactions
                            }
                          />
                        </div>
                      )}
                      {tab === "claim_hisot" && (
                        <div className='active' id='claim_hisot'>
                          <PolicyClaimHistory
                            claims={policy_history_details?.claim_history}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  "Something went wrong!"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PreviewPolicyAppSchedule
        modal_id='policy_schedule'
        // policyID={policyID}
        edit
        data={temp_policy_attach_data}
        policyDetails={customer_policy_details?.policy_app_details}
      />
      <ModalContainer
        modal_id='pay_premium'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <PayPremium
          customer_id={policy_history_details?.policy_app_details?.customerId}
          policy_app_no={
            policy_history_details?.policy_app_details?.policyAppNumber
          }
          policy_id={policy_history_details?.policy_app_rsk?.[0]?.policy_id}
        />
      </ModalContainer>
      <ModalContainer
        modal_id='confirm_renewal'
        modal_width='modal-sm'
        bradius='rounded-2'
      >
        <ConfirmUnderwrite
          handleSubmit={() => {}}
          title='Renewal'
          prompt='Are you sure you want to renew?'
          isTitle
          promptStyle='lh-sm fs-5'
          buttonText='Yes'
        />
      </ModalContainer>
    </>
  );
};

export default PolicyCycleView;
